import { gql } from "apollo-angular";

export const GETALL_TEST_SUITES_QUERY = gql`query configuratorAllTestSuites($Company: String, $RegBy: String, $OrgGroup: String) {
    configuratorAllTestSuites(Company: $Company, RegBy: $RegBy, OrgGroup: $OrgGroup) {
        Version
        Uid
        ItemNo
        Name
        ModifiedBy
        ModificationTime
        LockedTime
        LockedBy
        CreationTime
        CreatedBy
        Comment
        ApprovedForTestLevel
        ApprovalStatus
        Approval {
            Id
            Status
            ItemVersion
        }
    }
  }
  `
  
export const GET_TEST_SUITE_QUERY = gql`query configuratorTestSuiteById($Uid: String!) {
    configuratorTestSuiteById(Uid: $Uid) {
        responseMessages
        returnValue
        success
    }
  }
  `

export const GET_TEST_SUITE_UI_TEMPLATE_QUERY = gql`query configuratorTestSuiteUiTemplate {
    configuratorTestSuiteUiTemplate {
        Name
        Category
        DefaultValue
        FieldType
        IsMultiValue
        HasHierarchyValues
        IsReadOnly
        Label
        IsRequired
        Order
        Tooltip
        ValueList
    }
  }
  `

export const GET_TEST_SUITE_SEARCH_UI_TEMPLATE_QUERY = gql`query configuratorTestSuiteSearchUiTemplate {
    configuratorTestSuiteSearchUiTemplate {
        Name
        Label
        Category
        DefaultValue
        Order
        FieldType
        Tooltip
        IsReadOnly
        IsRequired
        IsMultiValue
        HasHierarchyValues
        ValueList
    }
  }
  `

export const SEARCH_TEST_SUITE_QUERY = gql`query configuratorSearchTestSuite($TestSuite: TestSuiteInput) {
  configuratorSearchTestSuite(TestSuite: $TestSuite) {
        Version
        Uid
        ItemNo
        Name
        ModifiedBy
        ModificationTime
        LockedTime
        LockedBy
        CreationTime
        CreatedBy
        Comment
        ApprovedForTestLevel
        ApprovalStatus
    }
}
`

export const GET_EXPORTED_TEST_SUITE_VERSION_QUERY = gql`query configuratorGetExportedTestSuiteVersion($Uid: String!) {
    configuratorGetExportedTestSuiteVersion(Uid: $Uid)
  }
  `